import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from '@/views/Login.vue'
import Error404 from '@/views/error/404.vue'
import Error500 from '@/views/error/500.vue'
import ItemList from '@/views/order/ItemList'
import ItemRegisterForm from '@/views/order/ItemRegisterForm'
import CsvUpload from '@/views/csv/CsvUpload'
import ItemImageUpload from '@/views/order/ItemImageUpload'
import Category from '@/views/order/Category'
import CategoryRegisterForm from '@/views/order/CategoryRegisterForm'
import UserList from '@/views/account/UserList'
import UserRegisterForm from '@/views/account/UserRegisterForm'
import EventList from '@/views/event/EventList'
import EventListRegisterForm from '@/views/event/EventListRegisterForm'
import Price from '@/views/order/Price'
import ShopSettingAll from '@/views/setting/ShopSettingAll'
import ShopList from '@/views/setting/ShopList'
import Qr from '@/views/setting/Qr'
import OrderRecommendRegisterForm from '@/views/ad/OrderRecommendRegisterForm'
import TimeRecommendRegisterForm from '@/views/ad/TimeRecommendRegisterForm'
import ShopListRegisterForm from '@/views/setting/ShopListRegisterForm'
import Group from '@/views/setting/Group'
import TimeRecommend from '@/views/ad/TimeRecommend'
import OrderRecommend from '@/views/ad/OrderRecommend'
import MenuTop from '@/views/order/menu/MenuTop'
import MenuRegisterForm from '@/views/order/menu/MenuRegisterForm'
import Bikkurapon from '@/views/setting/Bikkurapon'
import SearchTag from '@/views/order/SearchTag'
import store from './store/store'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true, // true:認証必須
        ExclusionTemplate: false, // true:Appテンプレート描画する
      },
    },
    {
      // ログイン
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requiresAuth: false,
        ExclusionTemplate: true,
      },
    },
    {
      // 時限式レコメンド
      path: '/ad/timeRecommend',
      name: 'timerRecommend',
      component: TimeRecommend,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 時限式レコメンド（新規登録）
      path: '/ad/timeRecommend/create',
      name: 'timerRecommendForm',
      component: TimeRecommendRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 時限式レコメンド（編集）
      path: '/ad/timeRecommend/:id',
      name: 'timerRecommendFormEdit',
      component: TimeRecommendRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 注文時レコメンド
      path: '/ad/orderRecommend',
      name: 'orderRecommend',
      component: OrderRecommend,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 注文時レコメンド（新規登録）
      path: '/ad/orderRecommend/create',
      name: 'orderRecommendForm',
      component: OrderRecommendRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 注文時レコメンド（編集）
      path: '/ad/orderRecommend/:id',
      name: 'orderRecommendFormEdit',
      component: OrderRecommendRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // イベント情報一覧
      path: '/event/event',
      name: 'event',
      component: EventList,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // イベント情報一覧（新規登録）
      path: '/event/event/create',
      name: 'eventForm',
      component: EventListRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // イベント情報一覧（編集）
      path: '/event/event/:id',
      name: 'eventFormEdit',
      component: EventListRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 商品一覧
      path: '/order/item',
      name: 'item',
      component: ItemList,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 商品一覧（新規登録）
      path: '/order/item/create',
      name: 'itemform',
      component: ItemRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 商品一覧（編集）
      path: '/order/item/edit/:id',
      name: 'itemformEdit',
      component: ItemRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 商品画像アップロード
      path: '/order/item/image',
      name: 'itemImageUpLoad',
      component: ItemImageUpload,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 検索設定一覧
      path: '/order/item/tag',
      name: 'searchTag',
      component: SearchTag,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 検索タグCSVアップロード
      path: '/order/item/tag/csv',
      name: 'sertchTagCsvUpload',
      component: CsvUpload,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // カテゴリー新規登録
      path: '/order/category/create',
      name: 'categoryCreate',
      component: CategoryRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // カテゴリー編集
      path: '/order/category/:id',
      name: 'categoryEdit',
      component: CategoryRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 商品CSVアップロード
      path: '/order/item/csv',
      name: 'itemlistUpload',
      component: CsvUpload,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 価格情報一覧
      path: '/order/price',
      name: 'price',
      component: Price,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 価格CSVアップロード
      path: '/order/price/csv',
      name: 'priceCsvUpload',
      component: CsvUpload,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // カロリーCSVアップロード
      path: '/order/item/calorie/csv',
      name: 'calorieCsvUpload',
      component: CsvUpload,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // カテゴリー一覧
      path: '/order/category',
      name: 'category',
      component: Category,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // カテゴリー一覧（新規登録）
      path: '/order/category/create',
      name: 'categoryform',
      component: CategoryRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // カテゴリー一覧（編集）
      path: '/order/category/:id',
      name: 'categoryformEdit',
      component: CategoryRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // メニュー
      path: '/order/menu',
      name: 'menu',
      component: MenuTop,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // メニュー（新規登録）
      path: '/order/menu/create',
      name: 'menuCreate',
      component: MenuRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // メニュー（編集）
      path: '/order/menu/edit',
      name: 'menuEdit',
      component: MenuRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // メニューCSVアップロード
      path: '/order/menu/csv',
      name: 'menuCsvUpload',
      component: CsvUpload,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // アカウント一覧
      path: '/account/user',
      name: 'user',
      component: UserList,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // アカウント登録
      path: '/account/user/create',
      name: 'userform',
      component: UserRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // アカウント編集
      path: '/account/user/:id',
      name: 'userformEdit',
      component: UserRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 全店一括設定
      path: '/setting/shopSettingAll',
      name: 'shopSettingAll',
      component: ShopSettingAll,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 店舗一覧
      path: '/setting/shop',
      name: 'shop',
      component: ShopList,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 店舗一覧（新規登録）
      path: '/setting/shop/create',
      name: 'shopform',
      component: ShopListRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 店舗一覧CSVアップロード
      path: '/setting/shop/csv',
      name: 'shopCsvUpload',
      component: CsvUpload,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 店舗一覧（編集）
      path: '/setting/shop/:id',
      name: 'shopFormEdit',
      component: ShopListRegisterForm,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // グループ設定
      path: '/setting/group/',
      name: 'group',
      component: Group,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // グループ設定CSVアップロード
      path: '/setting/group/csv',
      name: 'groupCsvUpload',
      component: CsvUpload,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // メニュー
      path: '/order/menu',
      name: 'menutop',
      component: MenuTop,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // QRコード表示
      path: '/setting/shop/:id/qr',
      name: 'qr',
      component: Qr,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // スマホでビッくらポン
      path: '/setting/bikkurapon',
      name: 'bikkurapon',
      component: Bikkurapon,
      meta: {
        requiresAuth: true,
        ExclusionTemplate: false,
      },
    },
    {
      // 404エラー
      path: '/404',
      name: '404Error',
      component: Error404,
      meta: {
        requiresAuth: false,
        ExclusionTemplate: true,
      },
    },
    {
      // 500エラー
      path: '/500',
      name: '500Error',
      component: Error500,
      meta: {
        requiresAuth: false,
        ExclusionTemplate: true,
      },
    },
    {
      path: '*',
      name: 'error',
      redirect: {
        name: '404Error',
      },
      meta: {
        requiresAuth: false,
        ExclusionTemplate: true,
      },
    },
  ],
})
// ログイン状態でルーティングを制御
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters['oauth/isLogin']) {
      next()
      return
    }

    next({
      name: 'login',
      query: { redirect: to.fullPath },
    })
  } else {
    next()
  }
})
export default router
